import { serverTimestamp } from "firebase/firestore";
import { localToUtcTimestamp, utcTimestampToLocal } from "../../utils/dateTimeUtils";

export class LocalAuthority {
  constructor(data) {
    this.id = data.id;
    this.name = data.name || "";
    this.code = data.code || "";
    this.region = data.region || "";
    this.alias = data.alias || "";
    this.isActive = data.isActive ?? true;
    this.allowedAsHome = data.allowedAsHome ?? false;
    this.allowedForSignupLocalAuthorityIds = data.allowedForSignupLocalAuthorityIds || [];

    // Metadata
    this.createdAt = utcTimestampToLocal(data.createdAt);
    this.updatedAt = utcTimestampToLocal(data.updatedAt);
    this.updatedBy = data.updatedBy || "";
  }

  static toJSON(data) {
    const now = serverTimestamp();

    return {
      id: data.id,
      name: data.name || "",
      code: data.code || "",
      region: data.region || "",
      alias: data.alias || "",
      isActive: true,
      allowedAsHome: data.allowedAsHome ?? false,
      allowedForSignupLocalAuthorityIds: data.allowedForSignupLocalAuthorityIds || [],
      createdAt: now,
      updatedAt: now,
      updatedBy: data.updatedBy || "",
    };
  }

  static toJsonUpdate(data) {
    // Start with a copy of the data
    const baseData = { ...data };

    // Always set updatedAt to now
    baseData.updatedAt = serverTimestamp();

    // Only convert dates if they exist in the input data
    if (data.createdAt) {
      baseData.createdAt = localToUtcTimestamp(data.createdAt);
    }

    return baseData;
  }
}

export default LocalAuthority;
